export {default as ShareOptaviaPlan} from './ShareOptaviaPlan.connect';
